import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import setCompanyAlias from 'utils/setCompanyAlias';
import setInterceptors from 'utils/setInterceptors';
import App from 'components/App';

const store = configureStore();
setCompanyAlias();
setInterceptors();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
